module.exports = __webpack_public_path__ + "img/new_certs-no-bg.bdf34436.png";